import { useContext, useState } from 'react';
import { Button, Modal, FormGroup } from 'react-bootstrap';
import { Plus } from 'react-bootstrap-icons';
import AsyncSelect from '../input/AsyncSelect';
import { roles } from '../../data/roles';
import ValidationOptionsInput from 'src/components/input/ValidationOptionsInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useAPI } from '../../services/api';
import ToastContext from '../../contexts/toast-context';

export const userCreateSchema = Yup.object({
  roleId: Yup.number().min(1).max(3).required(),
  username: Yup.string().max(255, 'Too long'),
  displayName: Yup.string().max(255, 'Too long'),
});

const AddUser = ({ updateUsers }) => {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  const [user, setUser] = useState(null);

  const api = useAPI();

  const { error, handleError, success } = useContext(ToastContext);

  const MIN_SEARCH_LENGTH = 3;

  const loadUsers = async (search) => {
    if (search.length < MIN_SEARCH_LENGTH) {
      return [];
    }
    let { data: users } = await api.get(`/users/search?name=${search}`);
    return users.map((user) => ({
      ...user,
      value: user.email,
      label: `${user.name} (${user.email.toUpperCase()})`,
    }));
  };

  const submit = async (values) => {
    if (!user) {
      return error('User is required!');
    }
    try {
      const roleId = parseInt(values.roleId);
      const username = user.email.toUpperCase();
      const displayName = user.name;
      const userData = { roleId, username, displayName };
      const { data } = await api.post('/users/', userData);
      updateUsers(data);
      closeModal();
      setUser(null);
      success('User Created!');
    } catch (e) {
      handleError(e);
    }
  };

  return (
    <>
      <Button className="m-2 d-flex align-items-center py-1" onClick={openModal}>
        <Plus className="me-1" size={24} />
        Add User
      </Button>
      <Modal show={showModal} onHide={closeModal} animation={false}>
        <Formik onSubmit={submit} initialValues={{ roleId: 2 }} validationSchema={userCreateSchema}>
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Add New User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup className="mb-2">
                <label className="mb-0" htmlFor="user-select">
                  User
                </label>
                <AsyncSelect
                  id="user-select"
                  value={user}
                  noOptionsMessage={(inputValue) => {
                    if (inputValue.length < MIN_SEARCH_LENGTH) {
                      return inputValue.length > 0
                        ? `Search must be at least ${MIN_SEARCH_LENGTH} characters.`
                        : 'Type to search for a user';
                    }
                    return 'No users found';
                  }}
                  onChange={setUser}
                  loadOptions={loadUsers}
                />
              </FormGroup>
              <ValidationOptionsInput
                name="roleId"
                label="Role"
                options={roles}
                noMargin
              ></ValidationOptionsInput>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={closeModal}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Create User
              </Button>
            </Modal.Footer>
          </Form>
        </Formik>
      </Modal>
    </>
  );
};

export default AddUser;
